import styled from 'styled-components';
import { GHMobileLink } from './GHMobileLink';

export const GlobalBackButton = styled(GHMobileLink)`
  padding-left: 1.2rem;
`;
